import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { WidgetProps } from "../widgets";

type BenefitsWidgetProps = {} & WidgetProps;

type IBenefit = {
	title: string;
	desc: string;
	icon: string;
	link: string;
	imageUrl?: string;
};

const benefits: IBenefit[] = [
	{
		title: "Equipment Request",
		icon: "",
		desc: "Request Medical Equipment including: Wheelchairs, Crutches, Canes, Knee Scooters, and more.",
		link: "",
	},
	{
		title: "Equipment Request",
		icon: "",
		desc: "Request Medical Equipment including: Wheelchairs, Crutches, Canes, Knee Scooters, and more.",
		link: "",
	},
];

export const BenefitsWidget: React.FC<BenefitsWidgetProps> = (props: BenefitsWidgetProps) => {
	// const [Component, setComponent] = useState<any>(null);

	useEffect(() => {}, []);

	return null;
	return (
		<div className="container section-padding pt-0">
			<h1>Benefits</h1>
			<p>
				Our members are family. No matter what, we are here for you. Enjoy a variety of benefits and a circle of
				peers ready to support one another.
			</p>
		</div>
	);
};
